import type { LoggerConfig } from '../types/LoggerConfig';
import { configure } from './config';
import { overrideOnError, overrideConsoleError } from './events';

export function init(config: LoggerConfig) {
    configure(config);

    if (config.overrideOnError) {
        overrideOnError();
    }

    if (config.overrideConsoleError) {
        overrideConsoleError();
    }
}
